import PropTypes from "prop-types";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";

const DeleteVoicemailModal = ({ open, onOpenChange, onConfirm }) => (
  <ConfirmDeleteDialog
    open={open}
    onOpenChange={onOpenChange}
    title="Delete voicemail?"
    description="Are you sure you want to delete this Voicemail?"
    onConfirm={onConfirm}
  />
);

DeleteVoicemailModal.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteVoicemailModal;
